import React from "react";
import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SiteLayout from "../site/SiteLayout";
import { lazyPage } from "../lib/lazyPage";
const Landing = lazyPage(() => import("./pages/Landing"));
const Assessment = lazyPage(() => import("./pages/Assessment"));
const ReportView = lazyPage(() => import("./pages/ReportView"));
const Learn = lazyPage(() => import("./pages/Learn"));
const Article = lazyPage(() => import("./pages/Article"));
const GiftToolkit = lazyPage(() => import("./pages/GiftToolkit"));
const DocumentChecklist = lazyPage(() => import("./pages/DocumentChecklist"));
const RentVsBuy = lazyPage(() => import("./pages/RentVsBuy"));
const Affordability = lazyPage(() => import("./pages/Affordability"));
import { VOICE } from "./copy";
import "./fthb.css";

const B = "/first-home-plan";

function Wrap({ children }) {
  return (<><Helmet><link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;0,600;0,700;0,800;0,900;1,500;1,600&family=Manrope:wght@400;500;600;700;800&display=swap" rel="stylesheet" /></Helmet><SiteLayout outside={<div className="fthb fthb-page" data-testid="fthb-root">{children}</div>} /></>);
}

export const FTHB_PATHS = [`${B}/`, `${B}/assessment`, `${B}/learn`, `${B}/gift-toolkit`, `${B}/document-checklist`, `${B}/rent-vs-buy`, `${B}/affordability`];

// Spread inside <Routes>: {fthbRoutes()}
export function fthbRoutes() {
  const pages = [
    ["/", () => <Landing copy={VOICE} />], ["/assessment", Assessment], ["/plan/:token", ReportView], ["/report/:token", ReportView],
    ["/learn", Learn], ["/learn/:slug", Article], ["/gift-toolkit", GiftToolkit], ["/document-checklist", DocumentChecklist],
    ["/rent-vs-buy", RentVsBuy], ["/affordability", Affordability],
  ];
  return pages.flatMap(([p, C]) => [B + p, B + p + "/"].filter((x, i, a) => a.indexOf(x) === i).map((path) => <Route key={path} path={path} element={<Wrap><C /></Wrap>} />));
}
